export const isExternalSlug = (link: string) =>
  link
    ? link.startsWith('http') ||
      link.startsWith('mailto') ||
      link.startsWith('tel')
    : false;

const fixSlug = (string = '') => {
  let str = string.toLowerCase();
  // ensure string starts with slash
  str = str.startsWith('/') ? str : '/' + str;
  // remove trailing slash
  str = str.endsWith('/') ? str.slice(0, -1) : str;

  return str;
};

export const getLocalizedLink = (slug: string) => {
  if (!slug) {
    return '';
  }

  if (isExternalSlug(slug)) {
    return slug;
  }

  const newSlug = fixSlug(slug);

  // if slug starts with en-US, sv-SE, etc.
  const regex = /^\/(en-\w{2})/g;

  if (regex.test(newSlug)) {
    return newSlug.replace(regex, '');
  }

  return newSlug;
};
